/* Homepage "Trusted by 27k+ Customers Worldwide" video slider:
   the whole video card links to its product page.
   Scoped to the video_presentation_trusted section only. */
document.addEventListener('click', function (e) {
  var card = e.target.closest('[id*="video_presentation_trusted"] .presentation-card');
  if (!card) return;
  var link = card.querySelector('a[href*="/products/"]');
  if (link) {
    e.preventDefault();
    window.location.href = link.getAttribute('href');
  }
});
